import React from 'react';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ParentDocCard from '../common/ParentDocCard';

export default function EditProjectConstant({
  showConstantUpdateForm,
  version,
  projectId,
  toggle,
}) {
  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <div className="card">
          <div className="card-header card-header-icon" data-background-color="drapcode-violet">
            <i className={`wb ${drapcodeIcon('form')}`}></i>
          </div>
          <div className="card-content">
            <div className="card-title-header">
              <h4 className="card-title">Edit App Constant</h4>

              <div className="card-cta"></div>
            </div>
            <div className="card-body">{showConstantUpdateForm()}</div>
            <div className="card-footer"></div>
          </div>
        </div>
      </div>

      <ParentDocCard>
        <h5>
          <b>About App Constant</b>
        </h5>
        <p>
          As the name suggests, constant is a value that stays fixed. Therefore, the constant
          settings allow you to apply a constant or fixed value to a filter for filtering the data
          entries with that constant value.
        </p>
        <br />
      </ParentDocCard>
    </>
  );
}
